// re-export so it's easy to find `tags.js` in Cmd+P palette
export * from "./tags";
